// Export for stubbing in tests
export const assignLocation = (location) => window.location.assign(location);
